var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-switch',{attrs:{"hide-details":"","label":_vm.label},model:{value:(_vm.modelValue),callback:function ($$v) {_vm.modelValue=$$v},expression:"modelValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }